<template>
    <div>
        <form-section
            id="buyer-profile"
            method="patch"
            :url="url"
            :read_only="read_only"
        >
            <buyer-contact
                v-if="is_broker || read_only || is_buyer_two"
                title="Buyer 1"
                field="buyer_1"
                :contact="contacts.buyer_1"
                :read_only="read_only || is_buyer_two"
                :is_lite="is_lite"
            />

            <div v-else>
                <form-row title="Your Information">
                    <div class="sm:col-gap-1 flex-1 -mt-4">
                        <input-text
                            name="buyer[name]"
                            v-model="client.name"
                            label="Name"
                            placeholder="Name"
                            :read_only="read_only"
                        />
                    </div>

                    <div class="sm:col-gap-1 flex-1 mt-2 sm:-mt-4">
                        <input-text
                            name="buyer[password]"
                            type="password"
                            v-model="client.password"
                            label="New Password (optional)"
                            :read_only="read_only"
                        />
                    </div>
                </form-row>
            </div>

            <buyer-contact
                v-if="! is_buyer_two"
                title="Buyer 2"
                field="buyer_2"
                :contact="contacts.buyer_2"
                :read_only="read_only"
                :is_lite="is_lite"
            />

            <div v-else>
                <form-row title="Your Information (Buyer 2)">
                    <div class="sm:col-gap-1 flex-1 -mt-4">
                        <input-text
                            name="buyer[name]"
                            v-model="contacts.buyer_2.name"
                            label="Name"
                            placeholder="Name"
                            :read_only="read_only"
                        />
                    </div>

                    <div class="sm:col-gap-1 flex-1 -mt-4">
                        <input-text
                            name="buyer[password]"
                            type="password"
                            v-model="client.password"
                            label="New Password (optional)"
                            :read_only="read_only"
                        />
                    </div>
                </form-row>
            </div>

            <buyer-contact
                title="Lawyer Contact"
                field="buyer_attorney"
                :contact="contacts.buyer_attorney"
                :read_only="read_only"
                :is_lite="is_lite"
            />

            <buyer-contact
                title="Mortgage Broker Contact"
                field="buyer_mortgage_broker"
                :contact="contacts.buyer_mortgage_broker"
                :read_only="read_only"
                :is_lite="is_lite"
            />

            <buyer-contact
                title="Real Estate Agent Contact"
                field="buyer_real_estate_agent"
                :contact="contacts.buyer_real_estate_agent"
                :read_only="read_only"
                :is_lite="is_lite"
            />

            <buyer-other-contacts
                v-if="! is_lite"
                :contacts="contacts.buyer_contact"
                :read_only="read_only"
            />
        </form-section>
    </div>
</template>

<script>
import FormSection from '../../components/form-section.vue';
import BuyerContact from './buyer-contact.vue';
import BuyerOtherContacts from './buyer-other-contacts.vue';

export default {
    components: {
        FormSection,
        BuyerContact,
        BuyerOtherContacts,
    },

    props: {
        client: {},
        user: {},
        contacts: {},
        is_broker: {},
        read_only: { default: false },
        property: {},
        url: {},
    },

    computed: {
        is_lite() {
            return this.user
                ? this.user.plan.category == 'residential quick track'
                : false;
        },
        is_buyer_two() {
            return this.user
                ? this.user.buyer_number == 'buyer_2'
                : false;
        },
    },
}
</script>
